import { render } from "./ConsentsView.vue?vue&type=template&id=39c08c87&scoped=true"
import script from "./ConsentsView.vue?vue&type=script&lang=js"
export * from "./ConsentsView.vue?vue&type=script&lang=js"

import "./ConsentsView.vue?vue&type=style&index=0&id=39c08c87&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39c08c87"]])

export default __exports__